module.exports = __webpack_public_path__ + "static/media/icon_event_sub.667e4bd8.svg";